export const DeactivatedSection = () => {
  return <></>;
};
